<template>
  <section>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <div class="tableBtn">
          <v-col>
          </v-col>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            ref="leaderTable"
            :headers="header"
            :items="datas"
            class="elevation-1"
            disable-pagination
            :hide-default-footer="true"
            item-key="itemKey"
        >
          <template v-slot:body="props">
            <draggable
                :list="datas"
                @change="changeOrder"
                tag="tbody"
            >

              <tr
                  v-for="(item, index) in props.items"
                  :key="index"
              >
                <td>
                  <v-icon
                      small
                      class="page__grab-icon"
                  >
                    mdi-arrow-all
                  </v-icon>
                </td>
                <td> {{ item.leaderName }} </td>
                <td> {{ item.groupPosition === 'chairman' ? '위원장' : '간사' }} </td>
                <td> {{ item.tenure }} </td>

                <td> {{ item.createdAt ? $moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss') : "" }} </td>
                <td>
                  <v-icon
                      small
                      @click="updateForm(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                      small
                      @click.stop="deleteLeader(item)"
                  >
                    mdi-delete
                  </v-icon>
                </td>
              </tr>

            </draggable>
          </template>

        </v-data-table>
        <div class="btnStyleBx">
          <div class="btnCommon justify-center">
            <v-btn class="vBtn" @click="createForm">
              <v-icon left>mdi mdi-playlist-plus</v-icon> 추가
            </v-btn>
          </div>
        </div>
      </div>
    </article>

    <v-dialog v-model="dialogVisible" max-width="500px" @click:outside="closeDialog" @keydown.esc="closeDialog">
      <v-card>
        <v-card-title>
          <span class="headline">역대 위원장 / 간사 {{ title }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="formLeader">
              <v-row>
                <v-col class="wh300">
                  <v-text-field :maxlength="10" v-model="leader.leaderName" label="이름" :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="wh300">
                  <v-text-field :maxlength="100" v-model="leader.tenure" label="재임기간" :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="wh300">
                  <v-select :items="positionList" v-model="leader.groupPosition" label="그룹내 직위" item-text="text"
                            item-value="value"
                            dense solo flat outlined clearable
                            :rules="[rules.required]"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import generationLeaderApi from "@/api/GenerationLeaderApi";

import _ from 'lodash';
import draggable from "vuedraggable";

export default {
  name: "GenerationLeaderList",
  components: {
    draggable,
  },
  props: {
    group: Object
  },
  watch: {
    group: {
      handler() {
        this.datas = [];
        this.getList();
      }
    }
  },
  data: () => ({
    leader: {
      groupPosition:'chairman'
    },
    positionList: [
      {
        text:'위원장',
        value:'chairman'
      },
      {
        text:'간사',
        value:'secretary'
      }
    ],
    title:'추가',
    rules: {
      required: value => !!value || '필수 입력 항목입니다..'
    },
    header:[
      {text: '순서', align: 'center', sortable: false},
      {
        text: '이름',
        value: 'leaderName',
        align: 'center',
        sortable: false
      },
      {
        text: '위원장 / 간사',
        value: 'groupPosition',
        align: 'center',
        sortable: false
      },
      {
        text: '재임기간',
        value: 'tenure',
        align: 'center',
        sortable: false
      },
      {
        text: '생성일',
        value: 'createdAt',
        align: 'center',
        sortable: false
      },
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    dialogVisible: false,
    datas: [],
    totalDesserts: 0,
    options:{},
    onRow:[],
    pagination: {
      sortBy: 'createdAt',
      rowsPerPage: 10
    },
    searchValue : '',
    searchActivated:null,
    searchType:null,
    mappings: [],
    waitingSearch:false,
  }),
  methods: {
    closeDialog() {
      this.dialogVisible = false;
    },
    changeOrder(e) {
      generationLeaderApi.order(e.moved.element.leaderId, (this.datas.length - 1) - e.moved.newIndex).then(() => {
        this.getList();
      });
    },
    createForm() {
      this.leader = {groupPosition: 'chairman'};
      this.dialogVisible = true;
      this.$refs?.formLeader?.resetValidation();
    },
    updateForm(item) {
      this.title = '수정'
      this.leader = _.cloneDeep(item);
      this.dialogVisible = true;
    },
    async save() {

      if(!this.group?.groupId??false) {
        alert('분과 또는 동호회를 선택해주세요.')
        return
      }
      if(!await this.$refs.formLeader.validate())
        return;

      this.leader.groupId = this.group.groupId;
      generationLeaderApi.save(this.leader).then(() => {
        this.getList();
      });

      this.dialogVisible = false;
    },
    deleteLeader(item) {
      if(confirm('삭제하시겠습니까?')) {
        generationLeaderApi.delete(item.leaderId).then(() => {
          this.getList();
        });
      }
    },
    getList() {
      if(this.group?.groupId??false) {
        this.loading = true
        // const { sortBy, sortDesc, page, itemsPerPage } = this.options
        // const {page, itemsPerPage} = this.options

        this.loading = false;
        // const param = {
        //   size: itemsPerPage,
        //   page
        // }
        generationLeaderApi.list(this.group.groupId).then(data => {
          this.datas = data;
          // this.totalDesserts = data.totalElements;
        });
      }
    }
  },
  created() {
    if(this.group?.groupId?? false)
      this.getList();
  }
}
</script>


<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.dashWrap {
  display: flex;
  flex-flow: row wrap;
}

.dashRow {
  //display: flex;
  //flex-direction: column;
  flex: 0 1 49%;

  &:first-child {
    margin-right: 2%;
  }
}

.dashRowFull {
  width: 100%;
  //
  //&:first-child {
  //  margin-right: 2%;
  //}
}

.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 38%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }

}

.h3Title {
  @include h3-title;
}
.tabContent{
  .formInfo {
    @include form-info;
  }
  .formInfoArea{
    &.align-normal{
      align-items: normal !important;
    };
  }
  .list{
    display: flex;
    width: 100% !important;
    img{
      width: 100%;
      height: auto;
    }
  }
  .wh300{
    width: 300px;
    padding: 0;
  }
}
.fieldWrap{
  @include form-bx;
  display: flex;
  align-items: center;
  padding: 5px 0 0 0;
  .fieldBx{
    position: relative;
    width: 100%;
    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 11px;
      &:last-child{
        margin-bottom: 0;
      }
      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        //margin-right: 1%;
        .formTit {
          @include form-font;
        }
        dd {
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .searchBtn{
    position: absolute;
    top: 32%;
    transform: translateY(-50%);
    right: 1.7%;
  }

}

.tableBtn {
  ul {
    display: flex;
    flex-direction: row;
    align-items: center;

    .tableBtnList {
      margin-right: 15px;
    }
  }
}
</style>